import PropTypes from 'prop-types';

const selectedLocationPropTypes = PropTypes.shape({
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  name: PropTypes.string,
});

export { selectedLocationPropTypes };
